<template>
  <table class="table">
    <tr v-for="(item, index) in condition.items">
      <th :rowspan=condition.items.length v-if="index == 0">{{condition.name}}</th>
      <th>{{item.middleName}}</th>
      <td>{{item[`${type}Quantity`]}}</td>
      <td>
        <template v-if="!checked">
          <md-checkbox
            class="md-primary"
            v-model="condition.checkList[item.itemId]"
            @change="changeCheckbox($event, item.itemId)"
          >
          </md-checkbox>
        </template>
        <template v-else>確認済み</template>
      </td>
    </tr>
  </table>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'QuantityCheckTable',
    props: {
      maintenanceId: Number,
      condition: {},
      type: String,
    },
    computed: {
      ...mapGetters([
        'maintenanceList'
      ]),
      checked: function() {
        if (this.maintenanceId === undefined) return false; // サイドパネルのボタンで遷移した時の対策
        const text = this.type.charAt(0).toUpperCase() + this.type.slice(1);
        const maintenance = Object.values(this.maintenanceList)
          .filter(v => v.maintenanceId === this.maintenanceId)[0];
        return maintenance[`isCheck${text}Quantity${this.condition.id}`];
      },
    },
    methods: {
      changeCheckbox: function(e, itemId) {
        this.$emit('changeCheckbox', e, itemId);
      },
    },
  };
</script>


<style lang="scss" scoped>
  table {
    margin-bottom: 2rem;
    border-bottom: 1px solid #cccccc;

    tr {
      >th,
      > td {
        border-color: #cccccc;
      }

      >th {
        &:nth-of-type(1) {
          width: 10%;
        }

        &:nth-of-type(2) {
          width: 58%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/QuantityCheckTable.vue?44bd78d5